import React, { useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import './Contact.css'

function Contact() {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        company: '',
        message: ''
    });

    const [submitStatus, setSubmitStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus('');

        try {
            const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxf2ElbcLVvsW-Pi4uUWIhZN1bXMdp2Q8kLCkMasWHIFLVPPBeunWDLdEHa_Mo2CS_V8w/exec';

            // Build URL with query parameters
            const params = new URLSearchParams({
                fullName: formData.fullName,
                email: formData.email,
                phone: formData.phone,
                company: formData.company,
                message: formData.message
            });

            // Send as GET request with query parameters (more reliable with Google Apps Script)
            const response = await fetch(`${SCRIPT_URL}?${params.toString()}`, {
                method: 'GET',
                redirect: 'follow'
            });

            // Parse the response
            const result = await response.json();
            console.log('Response:', result);

            if (result.status === 'success') {
                setSubmitStatus('success');
                setFormData({
                    fullName: '',
                    email: '',
                    phone: '',
                    company: '',
                    message: ''
                });
            } else {
                setSubmitStatus('error');
                console.error('Server error:', result.message);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className='contact'>
            <Navbar />
            <div className="contactContainer">
                <div className="contactHeader">
                    <p className='contactHeaderHeading'>Ready to Discuss Your GFRP Requirements?</p>
                    <p className='contactHeaderDescription'>Our team of experts is here to help you find the perfect solution for your construction project.</p>
                </div>

                <div className='contactMethods'>
                    <div className='contactForm'>
                        <p className='formKicker'>CONTACT BLITZ FIBER</p>
                        <h2 className='formHeading'>Send us a message</h2>

                        {submitStatus === 'success' && (
                            <div style={{
                                padding: '12px',
                                marginBottom: '16px',
                                backgroundColor: '#d4edda',
                                color: '#155724',
                                borderRadius: '4px',
                                border: '1px solid #c3e6cb'
                            }}>
                                ✓ Thank you! Your message has been sent successfully.
                            </div>
                        )}

                        {submitStatus === 'error' && (
                            <div style={{
                                padding: '12px',
                                marginBottom: '16px',
                                backgroundColor: '#f8d7da',
                                color: '#721c24',
                                borderRadius: '4px',
                                border: '1px solid #f5c6cb'
                            }}>
                                ✗ Something went wrong. Please try again or contact us directly.
                            </div>
                        )}

                        <form className='form' onSubmit={handleSubmit}>
                            <div className='formRow'>
                                <div className='formGroup'>
                                    <label htmlFor='fullName' className='formLabel'>Full Name</label>
                                    <input
                                        type='text'
                                        id='fullName'
                                        className='formInput'
                                        placeholder='Enter your full name'
                                        value={formData.fullName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <label htmlFor='email' className='formLabel'>Email</label>
                                    <input
                                        type='email'
                                        id='email'
                                        className='formInput'
                                        placeholder='your.email@example.com'
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className='formRow'>
                                <div className='formGroup'>
                                    <label htmlFor='phone' className='formLabel'>Phone Number</label>
                                    <input
                                        type='tel'
                                        id='phone'
                                        className='formInput'
                                        placeholder='+91 98765 43210'
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <label htmlFor='company' className='formLabel'>Company Name</label>
                                    <input
                                        type='text'
                                        id='company'
                                        className='formInput'
                                        placeholder='Your company name'
                                        value={formData.company}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className='formGroup'>
                                <label htmlFor='message' className='formLabel'>Message</label>
                                <textarea
                                    id='message'
                                    className='formTextarea'
                                    rows='5'
                                    placeholder='Tell us about your project requirements...'
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>
                            <button
                                type='submit'
                                className='formSubmit'
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
                            </button>
                        </form>
                    </div>
                    <div className='contactInfoContainer'>
                        <div className='contactInfoImageWrapper'>
                            <img
                                src="/architect.webp"
                                alt="Architect reviewing construction drawings"
                                className='contactInfoImage'
                            />
                        </div>
                        <div className='contactInfo'>

                            <p className='infoHeading'>Get in Touch</p>
                            <div className='infoItem'>
                                <svg className='infoIcon' viewBox="0 0 24 24" fill="none" stroke="#2C7138" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                </svg>
                                <p className='infoNumber'>+91 96546 22026</p>
                            </div>
                            <div className='infoItem'>
                                <svg className='infoIcon' viewBox="0 0 24 24" fill="none" stroke="#2C7138" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                    <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                                <p className='infoAddress'>plot gata number 125, bulanshshahr road, sikanddrabad, Uttar pradesh 203205</p>
                            </div>
                            <div className='infoItem'>
                                <svg className='infoIcon' viewBox="0 0 24 24" fill="none" stroke="#2C7138" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                    <polyline points="22,6 12,13 2,6"></polyline>
                                </svg>
                                <p className='infoEmail'>info.blitzfibresariya@gmail.com</p>
                            </div>
                            <div className='infoItem'>
                                <svg className='infoIcon' viewBox="0 0 24 24" fill="none" stroke="#2C7138" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                                <p className='infoTiming'>Monday - Friday: 9:00 AM - 5:00 PM</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mapSection'>
                    <div className='mapContainer'>
                        <iframe
                            className='mapIframe'
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.2233913121413!2d77.4051603706222!3d28.467375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDI4JzAyLjYiTiA3N8KwMjQnMTguNiJF!5e0!3m2!1sen!2sin!4v1234567890"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Factory Location"
                        ></iframe>
                        <div className='mapOverlay'>
                            <svg className='mapIcon' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                            </svg>
                            <p className='mapText'>Interactive Map</p>
                        </div>
                    </div>
                    <button className='directionsButton' onClick={() => {
                        // Replace these coordinates with your actual factory location
                        const factoryLat = 28.451133;
                        const factoryLng = 77.414380;
                        window.open(`https://www.google.com/maps/dir/?api=1&destination=${factoryLat},${factoryLng}`, '_blank');
                    }}>
                        Get Directions
                    </button>
                </div>
                {/* <div className='contactPageAboveFooter'>
                    <p className='aboveFooterHeading'>
                        Need Overview Of Our Services?
                    </p>
                    <p className='aboveFooterDescription'>
                        Get a detailed overview of our services and products.
                    </p>
                    <button className='aboveFooterButton'>Download Brochure</button>
                </div> */}
            </div>
            <Footer />
        </div >
    )
}
export default Contact